import type { MaterialGroupBy } from 'common/models';
import { useCustomTranslation } from 'helpers/translationHelper';
import React from 'react';

interface Props {
  visibleColumns?: string[];
  showPrice?: boolean;
  groupByKey?: MaterialGroupBy;
}

const MaterialTableHeader: React.FC<Props> = (props): React.ReactElement => {
  const { groupByKey, showPrice, visibleColumns } = props;

  const { t } = useCustomTranslation();

  return (
    <thead>
      <tr>
        {(!visibleColumns || visibleColumns.includes('name')) && (
          <th>{t('customData.material.name')}</th>
        )}
        {(!visibleColumns || visibleColumns.includes('identificationNumber')) && (
          <th>{t('customData.material.identificationNumber')}</th>
        )}
        {(!visibleColumns || visibleColumns.includes('storeName')) && groupByKey !== 'store' && (
          <th>{t('customData.material.storeName')}</th>
        )}
        {(!visibleColumns || visibleColumns?.includes('categoryName')) &&
          groupByKey !== 'category' && <th>{t('customData.material.categoryName')}</th>}
        {visibleColumns?.includes('supplierName') && (
          <th>{t('customData.material.supplierName')}</th>
        )}
        {visibleColumns?.includes('supplierCode') && (
          <th>{t('customData.material.supplierCode')}</th>
        )}
        {visibleColumns?.includes('description') && (
          <th>{t('customData.material.supplierCode')}</th>
        )}
        <th>{t('customData.material.amount')}</th>
        {showPrice && (
          <>
            <th className="priceCol">{t('customData.material.price')}</th>
            <th className="priceCol">{t('customData.material.totalPrice')}</th>
          </>
        )}
      </tr>
    </thead>
  );
};

export default MaterialTableHeader;
